var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1612",
    "data-name": "\\u9577\\u65B9\\u5F62 1612",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "#172b4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_636",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 636",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_635",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 635",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_136",
    "data-name": "\\u30D1\\u30B9 136",
    d: "M9,18a9,9,0,1,1,9-9,9.012,9.012,0,0,1-9,9M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5",
    transform: "translate(0 0.001)",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_137",
    "data-name": "\\u30D1\\u30B9 137",
    d: "M376.242,261.184a3.041,3.041,0,0,0-2.807-1.616,3.079,3.079,0,0,0-3.184,2.748.486.486,0,0,0,.483.543h.743a.468.468,0,0,0,.46-.4,1.367,1.367,0,0,1,1.5-1.2,1.333,1.333,0,0,1,1.3.7,1.1,1.1,0,0,1-.071,1.156,2.883,2.883,0,0,1-.719.66,2.5,2.5,0,0,0-1.227,2.183.478.478,0,0,0,.472.518h.731a.485.485,0,0,0,.483-.437.911.911,0,0,1,.52-.885,4.5,4.5,0,0,0,1.109-1.038,2.805,2.805,0,0,0,.212-2.924",
    transform: "translate(-364.401 -255.469)",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_138",
    "data-name": "\\u30D1\\u30B9 138",
    d: "M514.926,750.409a1.026,1.026,0,1,0,1.026,1.026,1.027,1.027,0,0,0-1.026-1.026",
    transform: "translate(-505.786 -738.56)",
    fill: "#172b4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.08e0744fddd153b3e4f68887ac2b4502.svg";
export { ForwardRef as ReactComponent };